import ApiClient from './ApiClient';

class IaReportsAPI extends ApiClient {
  constructor() {
    super('ia_metrics', { accountScoped: true });
  }

  getSummary(params = {}) {
    return axios.get(`${this.url}/summary`, { params });
  }

  getHandoffs(params = {}) {
    return axios.get(`${this.url}/handoffs`, { params });
  }
}

class ConversationAnalysisAPI extends ApiClient {
  constructor() {
    super('conversation_analysis_reports', { accountScoped: true });
  }

  getReports(params = {}) {
    return axios.get(this.url, { params });
  }

  getSummary(params = {}) {
    return axios.get(`${this.url}/summary`, { params });
  }

  analyzeConversation(conversationId) {
    return axios.post(`${this.url}/analyze`, { conversation_id: conversationId });
  }

  reanalyze(reportId) {
    return axios.post(`${this.url}/${reportId}/reanalyze`);
  }

  getPerformance(params = {}) {
    return axios.get(`${this.url}/performance`, { params });
  }
}

class PromptProposalsAPI extends ApiClient {
  constructor() {
    super('prompt_improvement_proposals', { accountScoped: true });
  }

  getProposals(params = {}) {
    return axios.get(this.url, { params });
  }

  getProposal(id) {
    return axios.get(`${this.url}/${id}`);
  }

  approve(id) {
    return axios.post(`${this.url}/${id}/approve`);
  }

  reject(id) {
    return axios.post(`${this.url}/${id}/reject`);
  }

  apply(id) {
    return axios.post(`${this.url}/${id}/apply`);
  }

  rollback(id) {
    return axios.post(`${this.url}/${id}/rollback`);
  }
}

export const iaReportsAPI = new IaReportsAPI();
export const conversationAnalysisAPI = new ConversationAnalysisAPI();
export const promptProposalsAPI = new PromptProposalsAPI();
